import { render, staticRenderFns } from "./TravelExpense.vue?vue&type=template&id=08fb4236&scoped=true&"
import script from "./TravelExpense.vue?vue&type=script&lang=js&"
export * from "./TravelExpense.vue?vue&type=script&lang=js&"
import style0 from "./TravelExpense.vue?vue&type=style&index=0&id=08fb4236&prod&lang=css&"
import style1 from "./TravelExpense.vue?vue&type=style&index=1&id=08fb4236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb4236",
  null
  
)

export default component.exports